const DialogId = {
  cancelRecurringPayment: 'cancel-recurring-payment-dialog',
  cancelRecurringPaymentConfirmation: 'cancel-recurring-payment-confirmation-dialog',
  changeCard: 'change-card-dialog',
  changeCardFailure: 'change-card-failure-dialog',
  changePaymentDate: 'change-payment-date-dialog',
  confirmSetup: 'confirm-setup-dialog',
  error: 'recurring-payment-error-dialog',
  paymentDateChangeConfirmation: 'payment-date-change-confirmation-dialog',
  paymentIframe: 'payment-iframe-dialog',
  redirecting: 'redirecting-dialog',
  selectPaymentDate: 'select-payment-date-dialog',
  setupConfirmation: 'setup-confirmation-dialog',
  setupFailure: 'setup-failure-dialog',
  updating: 'updating-dialog',
};

export default DialogId;